import caseImg from '../../assets/images/lamborghini_case.png';
import caseImg2 from '../../assets/images/lamborghini_case_2.png';

export const bannerVariations = [
	{
		name: 'Уникальный набор “Old Lamborghini”',
		textFirst: 'Новый кейс “Old Lamborghini” уже доступен в нашем магазине!',
		textSecond: 'Быстрее, пока не раскупили!',
		img: caseImg,
		color: '#17312f',
	},
	{
		name: 'Уникальный набор “Old Lamborghini”',
		textFirst: 'Новый кейс “Old Lamborghini” уже доступен в нашем магазине!',
		textSecond: 'Быстрее, пока не раскупили!',
		img: caseImg2,
		color: '#FFB500',
	},
];
